var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 88.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#293896;}.cls-2{fill:#73c167;}.cls-3{fill:#47c5f3;}.cls-4{fill:#4069b2;}.cls-5{fill:#eb203e;}.cls-6{fill:#f26924;}.cls-7{fill:#32c5f4;}.cls-8{fill:#148dcd;}.cls-9{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 32.28,
    width: 255.12,
    height: 55.85,
    rx: 20.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.5,46.16a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.5,53a2.74,2.74,0,1,0-2.74,2.73A2.74,2.74,0,0,0,17.5,53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.5,59.86a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.5,66.63a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M17.5,73.56a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.75,46.17A2.75,2.75,0,1,0,152,48.9a2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.75,59.87A2.75,2.75,0,1,0,152,62.61a2.74,2.74,0,0,0,2.74-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.75,66.65A2.75,2.75,0,1,0,152,69.38a2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.6,46.17a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.45,52.94a2.74,2.74,0,1,0-2.74,2.73,2.73,2.73,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.6,59.87a2.74,2.74,0,1,0-2.74,2.74,2.74,2.74,0,0,0,2.74-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.6,73.5a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M168.45,73.5a2.74,2.74,0,1,0-2.74,2.73,2.73,2.73,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M168.45,59.87a2.74,2.74,0,1,0-2.74,2.74,2.73,2.73,0,0,0,2.74-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M168.45,46.17a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.4,46.17a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.4,59.87a2.74,2.74,0,1,0-2.74,2.74,2.73,2.73,0,0,0,2.74-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.4,66.65a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.34,46.17a2.75,2.75,0,1,0-2.75,2.73,2.75,2.75,0,0,0,2.75-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.11,52.94a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M186.34,73.5a2.75,2.75,0,1,0-2.75,2.73,2.74,2.74,0,0,0,2.75-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M193.11,73.5a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.11,59.87a2.74,2.74,0,1,0-2.74,2.74,2.74,2.74,0,0,0,2.74-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.11,46.17a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.4,52.94a2.74,2.74,0,1,0-2.74,2.73,2.73,2.73,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M193.11,66.65a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.4,73.5a2.74,2.74,0,1,0-2.74,2.73,2.73,2.73,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M204.14,46.17a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M210.91,46.17a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M217.84,52.94a2.74,2.74,0,1,0-2.74,2.73,2.73,2.73,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M210.91,73.5a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M217.84,73.5a2.74,2.74,0,1,0-2.74,2.73,2.73,2.73,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M217.84,59.87a2.74,2.74,0,1,0-2.74,2.74,2.73,2.73,0,0,0,2.74-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M217.84,46.17a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M217.84,66.65a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M204.14,73.5a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M210.91,59.87a2.74,2.74,0,1,0-2.74,2.74,2.74,2.74,0,0,0,2.74-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M204.14,59.87a2.74,2.74,0,1,0-2.74,2.74,2.74,2.74,0,0,0,2.74-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.72,46.17A2.75,2.75,0,1,0,226,48.9a2.75,2.75,0,0,0,2.75-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.72,59.87A2.75,2.75,0,1,0,226,62.61a2.74,2.74,0,0,0,2.75-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.72,66.65A2.75,2.75,0,1,0,226,69.38a2.75,2.75,0,0,0,2.75-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M235.65,46.17a2.75,2.75,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.42,52.94a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M235.65,73.5a2.75,2.75,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M242.42,73.5a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.42,59.87a2.74,2.74,0,1,0-2.74,2.74,2.74,2.74,0,0,0,2.74-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.42,46.17a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.72,52.94A2.75,2.75,0,1,0,226,55.67a2.74,2.74,0,0,0,2.75-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M242.42,66.65a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.72,73.5A2.75,2.75,0,1,0,226,76.23a2.74,2.74,0,0,0,2.75-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M143.8,73.5a2.74,2.74,0,1,0-2.74,2.73,2.74,2.74,0,0,0,2.74-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M25.25,44.53h-1v2H25.3c.54,0,1-.23,1-1s-.52-1-1-1m.13,3H24.25v2.54H23V43.56h2.28c1.32,0,2.29.46,2.29,1.94s-.88,2-2.18,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.72,44.4c-1.19,0-1.75.72-1.75,2.43s.55,2.44,1.75,2.44,1.73-.83,1.73-2.44-.55-2.43-1.73-2.43m0,5.84c-2.34,0-3.06-1.47-3.06-3.41s.8-3.4,3.07-3.4,3,1.4,3,3.4-.77,3.41-3,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.77,44.53H37.55v1.85h1.23c.58,0,.85-.41.85-1a.8.8,0,0,0-.86-.9m1,5.52-2-2.7h-.29v2.7H36.29V43.56h2.43c1,0,2.2.34,2.2,1.87a1.74,1.74,0,0,1-1.61,1.88l2,2.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "45.06 44.54 45.06 50.05 43.8 50.05 43.8 44.54 42.01 44.54 42.01 43.56 46.85 43.56 46.85 44.54 45.06 44.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M50.76,50.24c-1.85,0-2.75-.85-2.75-2.59V43.56h1.27v4c0,1.45.67,1.72,1.48,1.72s1.36-.44,1.36-1.72v-4h1.26v4.11a2.31,2.31,0,0,1-2.62,2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.91,50.24c-2.39,0-3-1.69-3-3.44,0-2,.9-3.37,3.08-3.37a7.79,7.79,0,0,1,1.63.26l-.39,1.06A3.11,3.11,0,0,0,58,44.4c-1.06,0-1.79.51-1.79,2.4,0,1.56.38,2.47,1.72,2.47A1.74,1.74,0,0,0,59,49V47.55H57.54v-1H60.1v3.08a3.86,3.86,0,0,1-2.19.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M64.14,45l-.85,2.4h1.64Zm1.7,5.09-.58-1.74H62.94l-.61,1.74H61l2.64-6.49h1.16l2.45,6.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "68.47 50.05 68.47 43.56 69.73 43.56 69.73 49.05 72.43 49.05 72.43 50.05 68.47 50.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 22.99,
    y: 54.36,
    width: 4.27,
    height: 21.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "45.48 76.28 37.69 59.41 37.69 76.28 33.62 76.28 33.62 54.36 39.95 54.36 47.68 71.23 47.68 54.36 51.88 54.36 51.88 76.28 45.48 76.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.56,76.93c-7.39,0-10.1-4.68-10.1-11.59,0-6.1,2.44-11.42,10.24-11.42a20.21,20.21,0,0,1,5.79.88l-1.32,3.59A11.29,11.29,0,0,0,67.7,57.2c-4.31,0-5.83,3-5.83,8.1,0,5.39,1.45,8.34,5.62,8.34a12.27,12.27,0,0,0,4.91-1.36l1.33,3.6a17.52,17.52,0,0,1-6.17,1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.46,63.27c-2.44,0-3.73,1.39-3.73,5.18,0,3.49,1.15,5.36,3.73,5.36,2.37,0,3.69-1.59,3.69-5.36S87,63.27,84.46,63.27m0,13.49c-5.6,0-7.66-3.83-7.66-8.31,0-4.3,2.1-8.13,7.66-8.13s7.62,3.63,7.62,8.13S90,76.76,84.46,76.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M104.27,57.64h-2.88V73h3.18c3.39,0,5.76-1.33,5.76-7.73,0-6.91-2.71-7.63-6.06-7.63m0,18.64H97.12V54.36h7.15c7.08,0,10.47,2.88,10.47,10.87s-3.26,11-10.47,11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M125.51,63.3c-1.25,0-3.15.75-3.29,4h6.95c-.17-3-1.66-4-3.66-4M122.22,70c.31,2.48,1.6,3.87,3.73,3.87a11.53,11.53,0,0,0,4.85-1.32l1.25,2.94a16,16,0,0,1-6.37,1.22c-5,0-7.49-3.72-7.49-8,0-3.59,1.63-8.34,7.36-8.34,5.38,0,7.31,3.19,7.31,9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33,21.12l-.68-1.9c-.68.64-1.86,2.4-3.9,2.4-4.47,0-5.59-2.67-5.59-6.23V5.63H27.5V15.69c0,1,.06,2.41,1.79,2.41,1.39,0,2.17-1.59,3-3.09V5.63h4.64v12.2a18.87,18.87,0,0,0,.44,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.38,21.12V11.29c0-2.31-.68-2.65-1.6-2.65-1.76,0-2.84,1.7-3.42,3.26v9.22H50.72V11.29c0-2.44-.51-2.65-1.87-2.65s-2.57,2.31-3,3v9.43H41.23V9.18c0-1.28-.34-2.4-.44-3.55h4.3l.64,1.93c.48-.68,2.27-2.44,4-2.44,2.64,0,3.42.34,5,2.2.88-1.42,2.51-2.2,4.75-2.2,3.73,0,5.49,2,5.49,6.1v9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M79.29,21.12s-.61-1.5-.61-1.43c-.88.68-2.3,1.9-3.86,1.9-4.34,0-6.24-1.66-6.24-4.54,0-3.15,2-5.83,8.61-5.83h1.19v-.51c0-.75,0-2-1.77-2a14.37,14.37,0,0,0-5.86,1.36l-1.59-3.8a25.88,25.88,0,0,1,7.76-1.12c3.56,0,6.13,1.56,6.13,4.95v6.27c0,1.22.48,3.08.68,4.75Zm-.88-6.58h-.74c-3.06,0-4.28.78-4.28,2.31C73.39,18,74.75,18,75.77,18s2.06-1.05,2.64-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M107.29,21.12s-.61-1.5-.61-1.43c-.88.68-2.3,1.9-3.86,1.9-4.34,0-6.24-1.66-6.24-4.54,0-3.15,2-5.83,8.61-5.83h1.19v-.51c0-.75,0-2-1.77-2a14.37,14.37,0,0,0-5.86,1.36l-1.59-3.8a25.88,25.88,0,0,1,7.76-1.12c3.56,0,6.13,1.56,6.13,4.95v6.27c0,1.22.48,3.08.68,4.75Zm-.88-6.58h-.74c-3,0-4.28.78-4.28,2.31,0,1.11,1.36,1.18,2.38,1.18s2.06-1.05,2.64-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M123.9,21.56l-.13.4a2.39,2.39,0,0,1,2.34,2.51c0,3.19-2.85,4.48-5,4.48a34,34,0,0,1-3.76-.28l1.09-3A23.54,23.54,0,0,0,121,26a1.53,1.53,0,0,0,1.73-1.46c0-.92-.4-1.25-2.81-1.25l.51-2c-3.59-1-5.39-4-5.39-7.8,0-5,2.61-8.37,8.17-8.37a20.82,20.82,0,0,1,5.52,1.22L127,10c-1.15-.47-2.67-1.35-3.83-1.35-2.17,0-3.39.84-3.39,4.81,0,3.63,1.49,4.58,3.36,4.58a12,12,0,0,0,4-1.33l1.76,3.66A19.27,19.27,0,0,1,123.9,21.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M141.87,21.12s-.61-1.5-.61-1.43c-.88.68-2.31,1.9-3.87,1.9-4.33,0-6.23-1.66-6.23-4.54,0-3.15,2-5.83,8.61-5.83H141v-.51c0-.75,0-2-1.76-2a14.37,14.37,0,0,0-5.86,1.36l-1.6-3.8a26,26,0,0,1,7.77-1.12c3.56,0,6.13,1.56,6.13,4.95v6.27c0,1.22.47,3.08.68,4.75Zm-1.63-17c-2.07,0-2.47-1.63-3.52-1.63a1.79,1.79,0,0,0-1.8,1.26l-2.34-1.09A3.93,3.93,0,0,1,136.75,0c1.59,0,2.31,1.66,3.42,1.66A2.2,2.2,0,0,0,142,.07l2.31,1.12A4.26,4.26,0,0,1,140.24,4.17ZM141,14.54h-.75c-3.05,0-4.27.78-4.27,2.31C136,18,137.33,18,138.34,18S140.41,17,141,16.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M157.63,21.62c-5.79,0-8.06-3.86-8.06-8.33,0-4.31,2.3-8.17,8.06-8.17s8,3.66,8,8.17S163.39,21.62,157.63,21.62Zm0-13c-2,0-3.32.85-3.32,4.65,0,3.39,1.22,4.81,3.32,4.81,1.8,0,3.29-1.05,3.29-4.81S159.77,8.64,157.63,8.64Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncode);
export default __webpack_public_path__ + "static/media/incode.eec10787df51aab07ddfb1941d45c7fb.svg";
export { ForwardRef as ReactComponent };